/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { QueryMeasures, QueryMeasures$inboundSchema } from "./querymeasures.js";

/**
 * One row of the grouped table: measures aggregated over the full time range for a single group value.
 */
export type QueryRow = {
  /**
   * Distinct values of every allowlisted dimension other than the group_by dimension, observed within this group. Keyed by dimension identifier (the same keys used for group_by/filters, e.g. when grouping by department_name: 'email' -> [...], 'job_title' -> [...], 'role' -> [...]). Empty values are omitted and each list is capped.
   */
  dimensionValues: { [k: string]: Array<string> };
  /**
   * The dimension value for this row. Empty string when no group_by was requested; 'Other' for the rolled-up remainder beyond top_n.
   */
  groupValue: string;
  /**
   * Aggregated measure values for a group or time bucket
   */
  measures: QueryMeasures;
};

/** @internal */
export const QueryRow$inboundSchema: z.ZodMiniType<QueryRow, unknown> = z.pipe(
  z.object({
    dimension_values: z.record(z.string(), z.array(z.string())),
    group_value: z.string(),
    measures: QueryMeasures$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "dimension_values": "dimensionValues",
      "group_value": "groupValue",
    });
  }),
);

export function queryRowFromJSON(
  jsonString: string,
): SafeParseResult<QueryRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => QueryRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'QueryRow' from JSON`,
  );
}
